class ProductDescriptionReadMore extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('[data-product-description-content]');
    this.button = this.querySelector('[data-product-description-toggle]');

    if (!this.content || !this.button) return;

    this.button.addEventListener('click', this.toggle);
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.updateOverflow);
      this.resizeObserver.observe(this.content);
    }

    window.addEventListener('resize', this.updateOverflow);

    requestAnimationFrame(this.updateOverflow);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.toggle);
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.updateOverflow);
  }

  updateOverflow = () => {
    if (!this.content || !this.button) return;

    this.updateCollapsedHeight();

    const wasExpanded = this.dataset.expanded === 'true';

    if (wasExpanded) {
      this.content.style.setProperty('--product-description-expanded-height', `${this.content.scrollHeight}px`);
      return;
    }

    const overflows = this.content.scrollHeight > this.content.clientHeight + 1;
    this.dataset.overflows = overflows ? 'true' : 'false';
    this.button.hidden = !overflows;
  };

  updateCollapsedHeight() {
    if (!this.content) return;

    const styles = getComputedStyle(this);
    const contentStyles = getComputedStyle(this.content);
    const lineSetting = window.matchMedia('(min-width: 750px)').matches
      ? styles.getPropertyValue('--product-description-lines-desktop')
      : styles.getPropertyValue('--product-description-lines-mobile');
    const visibleLines = Number.parseFloat(lineSetting) || 5;
    const lineHeight = Number.parseFloat(contentStyles.lineHeight) || Number.parseFloat(contentStyles.fontSize) * 1.5;
    const paragraphSpacing = Number.parseFloat(styles.getPropertyValue('--font-paragraph--spacing')) || 0;

    this.content.style.setProperty(
      '--product-description-collapsed-height',
      `${lineHeight * visibleLines + paragraphSpacing}px`
    );
  }

  toggle = () => {
    if (!this.content || !this.button) return;

    const expanded = this.dataset.expanded === 'true';
    this.button.setAttribute('aria-expanded', String(!expanded));

    if (!expanded) {
      this.content.style.setProperty('--product-description-expanded-height', `${this.content.scrollHeight}px`);
      this.dataset.expanded = 'true';
    } else {
      this.dataset.expanded = 'false';
      this.content.style.removeProperty('--product-description-expanded-height');
      requestAnimationFrame(this.updateOverflow);
    }
  };
}

if (!customElements.get('product-description-read-more')) {
  customElements.define('product-description-read-more', ProductDescriptionReadMore);
}
